import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cart Filled"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cart-filled',
    templateUrl: './icon-cart-filled.component.html',
    styleUrls: ['./icon-cart-filled.component.scss'],
    standalone: false
})
export class IconCartFilledComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
